<script>
import { BCard } from "bootstrap-vue";

export default {
  extends: BCard
};
</script>